/**
 * Version 0.100
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2025.
 *
 * !Changelog
 *
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_firstload = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Trigger: modal and popup preloader
		 */
		images.preload();
		modal.onready();
		popup.onready();
		form.onready();
		if (pollConnection === 1) { poll_connection.onready(); }

		/**
		 * Trigger: onready classes
		 */
		specific_mobilemenu.onready();

		/**
		 * Visitor recording
		 */
		//specific_visitor_recording.onready();

		/**
		 * Trigger: onready specific classes
		 */
		specific_tabs.onready();

		/**
		 * If iframe is present and the content in the iframe is becoming heigher,
		 * then adjust the iframe height accordingly.
		 */
		// $('.js-iframe').on('load', function () {
		// 	var iframe = this;
		// 	setInterval(function () {
		// 		try {
		// 			iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';

		// 			$('.iframe-container').css('height', iframe.style.height);
		// 			$('.js-iframe').css('height', iframe.style.height);
		// 		} catch (e) {
		// 			// Cross-origin iframe access denied - skip height adjustment
		// 			console.warn('Cannot access iframe content due to cross-origin restrictions');
		// 		}

		// 	}, 500);
		// });

		$(document).on('click', '.js-button-wider', function () {

			$(this).hide();

			$('.js-wider').slideDown(1000);

			$('.js-narrow-hidden-image').slideUp(1500);
		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_firstload); 
